/**
 * Central registry of data-testid values.
 * Referenced by both the app and automated tests.
 */
export const T = {
  // Layout
  appShell: "app-shell",
  sidebar: "app-sidebar",
  sidebarEngineLink: (id) => `sidebar-engine-${id}`,
  sidebarClose: "sidebar-close",
  sidebarBackdrop: "sidebar-backdrop",
  topbar: "app-topbar",
  topbarClock: "topbar-clock",
  topbarMenuToggle: "topbar-menu-toggle",
  topbarHomeLink: "topbar-home-link",

  // Home ("Hoy")
  homeGreeting: "home-greeting",
  homeBriefing: "home-briefing",
  homeMoneyDial: "home-money-dial",
  homeEngineCard: (id) => `home-engine-card-${id}`, // still used by EngineCard.jsx (currently not rendered on Home, kept for reuse elsewhere)
  homeActionSoon: (id) => `home-action-soon-${id}`,
  homeWalletLink: "home-wallet-link",
  homeCommission: "home-commission-meter",
  homeNextConversation: "home-next-conversation",
  homeNextConversationCta: "home-next-conversation-cta",
  homeOtherConversations: "home-other-conversations",
  homeOtherConversationRow: (id) => `home-other-conversation-${id}`,
  homeVisionSection: "home-vision-section",
  homeVisionCard: (id) => `home-vision-card-${id}`,
  homeActivationPanel: "home-activation-panel",
  homeEcosystemSection: "home-ecosystem-section",

  // Wallet
  walletTable: "wallet-table",
  walletRow: (id) => `wallet-row-${id}`,
  walletSearch: "wallet-search",
  walletBlock: (key) => `wallet-block-${key}`,
  walletBlockShowMore: (key) => `wallet-block-show-more-${key}`,
  walletRest: "wallet-block-rest",
  walletViewAll: "wallet-view-all",
  walletBackToPriority: "wallet-back-to-priority",
  walletLoadMore: "wallet-load-more",

  // Recovery / Engine detail
  engineKpiMoneyDormant: "engine-kpi-money-dormant",
  engineKpiMoneyAwake: "engine-kpi-money-awake",
  engineKpiWinRate: "engine-kpi-win-rate",
  engineKpiVelocity: "engine-kpi-velocity",
  engineTopBillete: "engine-top-billete",
  engineOpportunityRow: (id) => `engine-opportunity-row-${id}`,

  // Opportunity detail
  oppDetailPanel: "opp-detail-panel",
  oppPlayCard: "opp-play-card",
  oppPlaySave: "opp-play-save",
  oppPlayCopy: "opp-play-copy",
  oppPlaySend: "opp-play-send",
  oppOutcomeBtn: (result) => `opp-outcome-${result}`,
  oppNotes: "opp-notes",
  oppNextAction: "opp-next-action",
  oppFirstActionMoment: "opp-first-action-moment",

  // Trabajo de hoy (antes "Turn mode")
  turnActiveTimer: "turn-active-timer",
  turnActiveCard: "turn-active-card",
  turnNext: "turn-next",
  turnEnd: "turn-end",
  turnSummary: "turn-summary",

  // Closures
  closuresTable: "closures-table",
  closuresTeamRanking: "closures-team-ranking",

  // Ingestion
  ingestDropzone: "ingest-dropzone",
  ingestFileInput: "ingest-file-input",
  ingestProcess: "ingest-process",
  ingestDownloadTemplate: "ingest-download-template",

  // Audit
  auditableFigure: "auditable-figure",
  auditableFigurePopover: "auditable-figure-popover",

  // Forecast / Executive
  forecastP50: "forecast-p50",
  forecastRange: "forecast-range",
  executiveEngineBar: (id) => `executive-engine-bar-${id}`,
};
